import { render, staticRenderFns } from "./reviewDetail.vue?vue&type=template&id=562623e8&lang=pug"
import script from "./reviewDetail.vue?vue&type=script&lang=js"
export * from "./reviewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports